import { ErrorTypes } from '../types/api';
import { getItem, queryItems, createItem, updateItem, bulkCreateItems, bulkDeleteItems, deleteItem, countItems, bulkUpdateItem, listItems } from '@wix/ambassador-restaurants-menus-v1-item/http';
import { BULK_DELETE_CHUNK_SIZE, MAX_NUMBER_OF_ITEMS_FROM_SERVER, orderEntitiesById, getEntityChunks, callInChunks } from './utils';
import { BaseAPIClient } from './BaseAPIClient';
export class ItemsClient extends BaseAPIClient {
  async getById(itemId) {
    const response = await this.request(getItem, {
      itemId
    });
    return response.data.item;
  }
  async getBulk(args) {
    var _args$ids;
    let idChunks;
    let items = [];
    let pagingMetadata;
    if (args != null && (_args$ids = args.ids) != null && _args$ids.length) {
      idChunks = getEntityChunks(args == null ? void 0 : args.ids, MAX_NUMBER_OF_ITEMS_FROM_SERVER);
      const itemsInChunks = await Promise.all(idChunks.map(async chunk => {
        const query = {
          filter: {
            id: {
              $in: chunk || []
            },
            ...(args == null ? void 0 : args.filter)
          }
        };
        const {
          data
        } = await this.request(queryItems, {
          query
        });
        return data.items || [];
      }));
      items.push(...itemsInChunks.flatMap(item => item));
      const itemsByClientOrder = orderEntitiesById(args == null ? void 0 : args.ids, items);
      items = itemsByClientOrder;
    } else {
      const {
        data
      } = await this.request(queryItems, {
        query: {
          cursorPaging: args == null ? void 0 : args.paging,
          ...((args == null ? void 0 : args.filter) && {
            filter: args == null ? void 0 : args.filter
          })
        }
      });
      items = data.items;
      pagingMetadata = data.pagingMetadata;
    }
    return {
      data: items || [],
      pagingMetadata
    };
  }
  async getListBulk(args) {
    const {
      data
    } = await this.request(listItems, {
      paging: args == null ? void 0 : args.paging
    });
    const items = data.items || [];
    const pagingMetadata = data.pagingMetadata;
    return {
      data: items || [],
      pagingMetadata
    };
  }
  async create(item, source) {
    const response = await this.request(createItem, {
      item,
      source
    });
    return response.data.item;
  }
  async update(item) {
    const response = await this.request(updateItem, {
      item
    });
    return response.data.item;
  }
  async bulkUpdate(items) {
    const response = await this.request(bulkUpdateItem, {
      items: items.map(item => ({
        item
      }))
    });
    return response.data.results;
  }
  async delete(itemId) {
    const response = await this.request(deleteItem, {
      itemId
    });
    return response.data;
  }
  async query(query) {
    const {
      data: {
        items = [],
        pagingMetadata
      }
    } = await this.request(queryItems, {
      query
    });
    return {
      data: items,
      pagingMetadata
    };
  }
  async countItems(filter) {
    const response = await this.request(countItems, {
      filter
    });
    return response.data.count;
  }
  async bulkCreate(items, source) {
    const {
      results
    } = await callInChunks(async chunk => {
      return this.request(bulkCreateItems, {
        items: chunk,
        source,
        returnEntity: true
      });
    }, items);
    return (results || []).map(result => result.item);
  }
  async bulkDelete(itemIds) {
    var _response$bulkActionM;
    const response = await callInChunks(chunkItemIds => this.request(bulkDeleteItems, {
      ids: chunkItemIds
    }), itemIds, BULK_DELETE_CHUNK_SIZE);
    if ((_response$bulkActionM = response.bulkActionMetadata) != null && _response$bulkActionM.totalFailures) {
      var _response$results;
      const errors = ((_response$results = response.results) == null ? void 0 : _response$results.filter(result => {
        var _result$itemMetadata;
        return (_result$itemMetadata = result.itemMetadata) == null ? void 0 : _result$itemMetadata.error;
      })) || [];
      const errorMessage = {
        name: ErrorTypes.BULK_DELETE_ITEMS,
        message: errors.map(result => {
          var _result$itemMetadata2;
          return (_result$itemMetadata2 = result.itemMetadata) == null ? void 0 : _result$itemMetadata2.error;
        }).join(', ')
      };
      throw new Error('Failed to delete items', {
        cause: errorMessage
      });
    }
    return {};
  }
}
//# sourceMappingURL=ItemsClient.js.map